module.exports = __webpack_public_path__ + "static/media/nft-34.f3d0a666.jpg";